<template>
  <div>
    <div class="nav-vertical">
      <ul class="nav nav-tabs nav-left" role="tablist">
        <li class="nav-item">
          <a
            role="tab"
            data-toggle="tab"
            class="nav-link"
            @click.prevent="setActive('#t1' + rowData.doc_id + '')"
            :class="{ active: isActive('#t1' + rowData.doc_id + '') }"
            v-bind:href="'#t1' + rowData.doc_id + ''"
          >
            Partes envolvidas <i class="fa fa-user"></i
          ></a>
        </li>
        <li class="nav-item">
          <a
            role="tab"
            data-toggle="tab"
            class="nav-link"
            @click.prevent="setActive('#t2' + rowData.doc_id + '')"
            :class="{ active: isActive('#t2' + rowData.doc_id + '') }"
            v-bind:href="'#t2' + rowData.doc_id + ''"
          >
            Notas Fiscais <i class="fa fa-files-o"></i
          ></a>
        </li>
        <!-- <li class="nav-item" v-if="rowData.doc_carga_doc[0].carga_doc.doc_fiscal.doc_fiscal_unidade.length>0">
                  <a role="tab" data-toggle="tab" class="nav-link" @click.prevent="setActive('#t3'+rowData.doc_id+'')" :class="{ active: isActive('#t3'+rowData.doc_id+'') }" v-bind:href="'#t3'+rowData.doc_id+''">Unidades</a>
                </li> -->
        <li class="nav-item">
          <a
            role="tab"
            data-toggle="tab"
            class="nav-link"
            @click.prevent="setActive('#t4' + rowData.doc_id + '')"
            :class="{ active: isActive('#t4' + rowData.doc_id + '') }"
            v-bind:href="'#t4' + rowData.doc_id + ''"
          >
            Observação <i class="fa fa-archive"></i
          ></a>
        </li>
      </ul>

      <div class="tab-content">
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          :class="{ 'active show': isActive('#t1' + rowData.doc_id + '') }"
          v-bind:id="'#t1' + rowData.doc_id + ''"
        >
          <table class="table-striped" id="mais">
            <thead>
              <tr>
                <th data-toggle="true" style="width: 5%"></th>
                <th data-toggle="true" style="width: 10%">CNPJ / CPF</th>
                <th data-toggle="true" style="width: 10%">IE</th>
                <th data-toggle="true" style="width: 10%">Nome</th>
                <th data-toggle="true" style="width: 10%">Município</th>
                <th data-toggle="true" style="width: 3%">Estado</th>
                <th data-toggle="true" style="width: 15%">Endereço</th>
                <th data-toggle="true" style="width: 12%">Bairro</th>
                <th data-toggle="true" style="width: 10%">CEP</th>
                <th data-toggle="true" style="width: 10%">Email</th>
                <th data-toggle="true" style="width: 5%">Telefone</th>
              </tr>
            </thead>

            <tbody>
              <tr class="bg-gray-light" style="display: table-row;">
                <td>
                  <span class="badge badge-primary">Emitente</span>
                </td>
                <td>
                  <span v-if="rowData.doc_cte_partes_env.emi_cnpj != null">{{
                    ajustaMascara(rowData.doc_cte_partes_env.emi_cnpj)
                  }}</span>
                  <span v-if="rowData.doc_cte_partes_env.emi_cpf != null">{{
                    ajustaMascara(rowData.doc_cte_partes_env.emi_cpf)
                  }}</span>
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.emi_ie }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.emi_nome }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.emi_nome_municipio }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.emi_uf }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.emi_endereco }} -
                  {{ rowData.doc_cte_partes_env.emi_complemento }} -
                  {{ rowData.doc_cte_partes_env.emi_numero }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.emi_bairro }}
                </td>
                <td>
                  <span v-if="rowData.doc_cte_partes_env.emi_cep">{{
                    rowData.doc_cte_partes_env.emi_cep.toString().padStart(8, "0")
                  }}</span>
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.emi_email }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.emi_telefone }}
                </td>
                <td>
                  <a
                    v-if="
                      getPermission('montagemcarga.update') &&
                        rowData.carga_doc &&
                        rowData.carga_doc.doc_carga_doc &&
                        rowData.carga_doc.doc_carga_doc.doc
                    "
                    @click="onEditaPartesEnv(rowData.doc_cte_partes_env)"
                    v-b-tooltip
                    title="Editar"
                    ><i class="fa fa-edit"></i
                  ></a>
                </td>
              </tr>
            </tbody>

            <tbody>
              <tr class="bg-gray-light" style="display: table-row;">
                <td>
                  <span class="badge badge-info">Tomador</span>
                </td>
                <td>
                  <span v-if="rowData.doc_cte_partes_env.tom_cnpj != null">{{
                    ajustaMascara(rowData.doc_cte_partes_env.tom_cnpj)
                  }}</span>
                  <span v-if="rowData.doc_cte_partes_env.tom_cpf != null">{{
                    ajustaMascara(rowData.doc_cte_partes_env.tom_cpf)
                  }}</span>
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.tom_ie }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.tom_nome }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.tom_nome_municipio }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.tom_uf }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.tom_endereco }} -
                  {{ rowData.doc_cte_partes_env.tom_complemento }} -
                  {{ rowData.doc_cte_partes_env.tom_numero }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.tom_bairro }}
                </td>
                <td>
                  <span v-if="rowData.doc_cte_partes_env.tom_cep">{{
                    rowData.doc_cte_partes_env.tom_cep.toString().padStart(8, "0")
                  }}</span>
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.tom_email }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.tom_telefone }}
                </td>
                <td>
                  <a
                    v-if="
                      getPermission('montagemcarga.update') &&
                        rowData.carga_doc &&
                        rowData.carga_doc.doc_carga_doc &&
                        rowData.carga_doc.doc_carga_doc.doc
                    "
                    @click="onEditaPartesEnv(rowData.doc_cte_partes_env)"
                    v-b-tooltip
                    title="Editar"
                    ><i class="fa fa-edit"></i
                  ></a>
                </td>
              </tr>
            </tbody>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row;">
                <td>
                  <span class="badge badge-success">Destinatário</span>
                </td>
                <td>
                  <span v-if="rowData.doc_cte_partes_env.des_cnpj != null">{{
                    ajustaMascara(rowData.doc_cte_partes_env.des_cnpj)
                  }}</span>
                  <span v-if="rowData.doc_cte_partes_env.des_cpf != null">{{
                    ajustaMascara(rowData.doc_cte_partes_env.des_cpf)
                  }}</span>
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.des_ie }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.des_nome }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.des_nome_municipio }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.des_uf }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.des_endereco }} -
                  {{ rowData.doc_cte_partes_env.des_complemento }} -
                  {{ rowData.doc_cte_partes_env.des_numero }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.des_bairro }}
                </td>
                <td>
                  <span v-if="rowData.doc_cte_partes_env.des_cep">{{
                    rowData.doc_cte_partes_env.des_cep.toString().padStart(8, "0")
                  }}</span>
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.des_email }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.des_telefone }}
                </td>
                <td>
                  <a
                    v-if="
                      getPermission('montagemcarga.update') &&
                        rowData.carga_doc &&
                        rowData.carga_doc.doc_carga_doc &&
                        rowData.carga_doc.doc_carga_doc.doc
                    "
                    @click="onEditaPartesEnv(rowData.doc_cte_partes_env)"
                    v-b-tooltip
                    title="Editar"
                    ><i class="fa fa-edit"></i
                  ></a>
                </td>
              </tr>
            </tbody>

            <tbody>
              <tr class="bg-gray-light" style="display: table-row;">
                <td>
                  <span class="badge badge-secondary">Recebedor</span>
                </td>
                <td>
                  <span v-if="rowData.doc_cte_partes_env.rec_cnpj != null">{{
                    ajustaMascara(rowData.doc_cte_partes_env.rec_cnpj)
                  }}</span>
                  <span v-if="rowData.doc_cte_partes_env.rec_cpf != null">{{
                    ajustaMascara(rowData.doc_cte_partes_env.rec_cpf)
                  }}</span>
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.rec_ie }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.rec_nome }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.rec_nome_municipio }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.rec_uf }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.rec_endereco }} -
                  {{ rowData.doc_cte_partes_env.rec_complemento }} -
                  {{ rowData.doc_cte_partes_env.rec_numero }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.rec_bairro }}
                </td>
                <td>
                  <span v-if="rowData.doc_cte_partes_env.rec_cep">{{
                    rowData.doc_cte_partes_env.rec_cep.toString().padStart(8, "0")
                  }}</span>
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.rec_email }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.rec_telefone }}
                </td>
                <td>
                  <a
                    v-if="
                      getPermission('montagemcarga.update') &&
                        rowData.carga_doc &&
                        rowData.carga_doc.doc_carga_doc &&
                        rowData.carga_doc.doc_carga_doc.doc
                    "
                    @click="onEditaPartesEnv(rowData.doc_cte_partes_env)"
                    v-b-tooltip
                    title="Editar"
                    ><i class="fa fa-edit"></i
                  ></a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          :class="{ 'active show': isActive('#t2' + rowData.doc_id + '') }"
          v-bind:id="'#t2' + rowData.doc_id + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 5%">Tipo</th>
                <th style="width: 25%">Chave</th>
                <th style="width: 10%">N° Fiscal</th>
                <th style="width: 5%">Série</th>
                <th style="width: 5%">Data Emissão</th>
                <th style="width: 10%">CNPJ</th>
                <th style="width: 10%">Razão Social</th>
                <th style="width: 10%">Inscrição Estadual</th>
                <th style="width: 10%">Ações</th>
              </tr>
            </thead>
            <tbody v-for="item in rowData.doc_carga_doc">
              <tr class="bg-gray-light" style="display: table-row;">
                <td>
                  {{ item.carga_doc.doc_fiscal.tp_doc }}
                </td>
                <td>
                  {{ item.carga_doc.doc_fiscal.chave }}
                </td>
                <td>
                  {{ item.carga_doc.doc_fiscal.num_fiscal }}
                </td>
                <td>
                  {{ item.carga_doc.doc_fiscal.serie }}
                </td>
                <td>
                  {{
                    formatDate(
                      item.carga_doc.doc_fiscal.dt_emissao,
                      "DD/MM/YYYY"
                    )
                  }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.emi_cnpj }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.emi_nome_fantasia }}
                </td>
                <td>
                  {{ rowData.doc_cte_partes_env.emi_ie }}
                </td>
                <td>
                  <!-- <a v-b-tooltip title="Ver detalhes"><i class="fa fa-plus"></i></a> -->
                  <a
                    @click="onDetail(item.carga_doc.docfis_id)"
                    v-b-tooltip
                    title="Ver detalhes"
                    ><i class="fa fa-plus"></i
                  ></a>
                </td>
              </tr>
              <tr v-if="isVisibleDetail(item.carga_doc.docfis_id)">
                <td colspan="9">
                  <section class="tabs-section">
                    <ul
                      class="nav nav-tabs nav-topline nav-justified"
                      role="tablist"
                    >
                      <li class="nav-item">
                        <a
                          class="nav-link active"
                          v-bind:href="'#tr1' + item.carga_doc.docfis_id + ''"
                          role="tab"
                          data-toggle="tab"
                        >
                          <span class="nav-link-in">
                            Itens
                            <i class="fa fa-map-marker"></i>
                          </span>
                        </a>
                      </li>
                      <li class="nav-item">
                        <a
                          class="nav-link"
                          v-bind:href="'#tr2' + item.carga_doc.docfis_id + ''"
                          role="tab"
                          data-toggle="tab"
                          v-if="
                            item.carga_doc.doc_fiscal.doc_fiscal_unidade
                              .length > 0
                          "
                        >
                          <span class="nav-link-in">
                            Unidade
                            <i class="fa fa-map-marker"></i>
                          </span>
                        </a>
                      </li>
                    </ul>
                    <div class="tab-content">
                      <div
                        role="tabpanel"
                        class="tab-pane fade in active show pt-1 border-color-detalhes-grey"
                        v-bind:id="'tr1' + item.carga_doc.docfis_id + ''"
                      >
                        <table
                          :class="['vuetable table table-striped tbl-typical']"
                        >
                          <thead>
                            <tr>
                              <th style="width: 10%">Cód Produto</th>
                              <th style="width: 35%">Descrição</th>
                              <th style="width: 5%">NCM</th>
                              <th style="width: 5%">CFOP</th>
                              <th style="width: 5%">Uid.Med.</th>
                              <th style="width: 5%">Qtde.</th>
                              <th style="width: 5%">Peso Bruto</th>
                              <th style="width: 5%">Peso Liquído</th>
                              <th style="width: 5%">Volume</th>
                              <th style="width: 5%">Vlr.Item</th>
                            </tr>
                          </thead>
                          <tbody
                            v-for="item_itens in item.carga_doc.doc_fiscal
                              .doc_fiscal_produto"
                          >
                            <tr
                              class="bg-gray-light"
                              style="display: table-row;"
                            >
                              <td>
                                {{ item_itens.cd_produto }}
                              </td>
                              <td>
                                {{ item_itens.descr_produto }}
                              </td>
                              <td>
                                {{ item_itens.ncm }}
                              </td>
                              <td>
                                {{ item_itens.cfop }}
                              </td>
                              <td>
                                {{ item_itens.unidade_comercial }}
                              </td>
                              <td>
                                {{ item_itens.qtd_comercial }}
                              </td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td>
                                {{ formatNumber(item_itens.vlr_bruto) }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div
                        role="tabpanel"
                        class="tab-pane fade pt-1 border-color-detalhes-grey"
                        v-bind:id="'tr2' + item.carga_doc.docfis_id + ''"
                      >
                        <table
                          :class="['vuetable table table-striped tbl-typical']"
                        >
                          <thead>
                            <tr>
                              <th style="width: 10%">Cód Unidade</th>
                              <th style="width: 35%">Unidade</th>
                            </tr>
                          </thead>
                          <tbody
                            v-for="item_unidade in item.carga_doc.doc_fiscal
                              .doc_fiscal_unidade"
                          >
                            <tr
                              class="bg-gray-light"
                              style="display: table-row;"
                            >
                              <td>
                                {{ item_unidade.unidade.cd }}
                              </td>
                              <td>
                                {{ item_unidade.unidade.descr }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </section>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <!-- <div  role="tabpanel" class="tab-pane fade pt-1 border-color-detalhes-grey" :class="{ 'active show': isActive('#t3'+rowData.doc_id+'') }" v-bind:id="'#t3'+rowData.doc_id+''" v-if="rowData.doc_fiscal_unidade.length>0">
                <table class="table" id="mais">
                    <thead>
                        <tr>
                            <th style="width: 10%">Código</th>
                            <th style="width: 90%">Descrição</th>
                        </tr>
                     </thead>
                     <tbody>
                         <tr class="bg-gray-light" style="display: table-row;" v-for="(item, i) in rowData.doc_carga_doc">
                            <td>
                                {{ item.carga_doc.doc_fiscal.doc_fiscal_unidade[i].unidade.cd }}
                            </td>
                            <td>
                                {{ item.carga_doc.doc_fiscal.doc_fiscal_unidade[i].item.unidade.descr }}
                            </td>
                        </tr>
                    </tbody>
                </table>
        </div> -->
        <!--.tab-pane-->

        <div
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          :class="{ 'active show': isActive('#t4' + rowData.doc_id + '') }"
          v-bind:id="'#t4' + rowData.doc_id + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 20%">Observação</th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-gray-light" style="display: table-row;">
                <td>
                  <span
                    v-if="
                      rowData.doc_cte != null &&
                        rowData.doc_cte.doc_cte_adicional.observacao_geral !=
                          null
                    "
                    >{{ rowData.doc_cte.doc_cte_adicional.observacao_geral }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
      </div>
      <!--.tab-content-->
      <MontagemCargaPartesEnvForm ref="montagemcargapartesenv">
      </MontagemCargaPartesEnvForm>
    </div>
  </div>
</template>
<script>
import accounting from "accounting";
import moment from "moment";
import MontagemCargaPartesEnvForm from "./MontagemCargaPartesEnvForm";

export default {
  components: {
    MontagemCargaPartesEnvForm,
  },
  data() {
    return {
      abaAtiva: "",
      visibleDetailRows: [],
      helpForm: new Form({ statusRecord: [], params: [] }),
    };
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
    },
  },
  mounted() {
    this.$parent.visibleDetailRows.forEach((item, i) => {
      this.abaAtiva = "#t1" + item + "";
    });
  },
  methods: {
    isActive(aba) {
      return this.abaAtiva === aba;
    },
    setActive(aba) {
      this.abaAtiva = aba;
    },
    onEditaPartesEnv(data) {
      this.$refs.montagemcargapartesenv.onEdit(data);
    },
    ajustaMascara(data) {
      if (data != null) {
        if (data.length == 11) {
          //cpf
          return data.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
        }
        if (data.length == 14) {
          //cnpj
          return data.replace(
            /([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})([A-Z0-9]{2})/,
            "$1.$2.$3/$4-$5"
          );
        }
      }
    },
    formatNumber(value) {
      return accounting.formatNumber(value, 2, ".", ",");
    },
    formatDate(value, fmt = "D MMM YYYY") {
      return value == null ? "" : moment(value, "YYYY-MM-DD").format(fmt);
    },
    onReloadVuetable() {
      this.$refs.vuetable.reload();
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },

    onDetail(docfis_id) {
      this.toggleDetail(docfis_id);
    },
    isVisibleDetail(rowId) {
      return this.visibleDetailRows.indexOf(rowId) >= 0;
    },
    showDetail(rowId) {
      if (!this.isVisibleDetail(rowId)) {
        this.visibleDetailRows.push(rowId);
      }
    },
    hideDetail(rowId) {
      if (this.isVisibleDetail(rowId)) {
        this.visibleDetailRows.splice(this.visibleDetailRows.indexOf(rowId), 1);
      }
    },
    toggleDetail(rowId) {
      if (this.isVisibleDetail(rowId)) {
        this.hideDetail(rowId);
      } else {
        this.showDetail(rowId);
      }
    },
  },
};
</script>
